import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import Icon from "../Common/Icon";
import Sharing from "./Sharing";
import ReactModal from "react-modal";
import Accessibility from "../Common/Accessibility";
import { getIsRequiredFlexLoading } from "../../utils/flexRules";
import { getOccupancySpan } from "../../utils/shared";

class Detail extends Component {
  static propTypes = {
    config: PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      stepExtraIsVisible: [],
      showModal: false,
      stopId: null,
      stopAddress: null,
    };
  }

  handleOpenModal = (stopId, stopAddress) => {
    this.setState({ showModal: true, stopId, stopAddress });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false, stopId: null, stopAddress: null });
  };

  render() {
    const {
      loading,
      steps,
      selectedDate,
      config,
      ludMessages = [],
      plannerType,
    } = this.props;

    if (config.sharing) config.sharing.logo.logoName = plannerType;

    var differentDate = false;
    var dateString = "";
    moment.locale("nl-nl");
    if (
      steps &&
      moment(steps[0].startTime).format("DD-MM-YYYY") !== selectedDate
    ) {
      differentDate = true;
      dateString = moment(steps[0].startTime).format("dddd D MMMM YYYY");
      dateString = dateString[0].toUpperCase() + dateString.substr(1);
    }
    const { minutesDelayText } = this.props.config;
    const defaultStartAddress = this.props.config.startAddress || "";
    const defaultEndAddress = this.props.config.endAddress || "";
    return (
      <React.Fragment>
        <div className="container container--center container--margin">
          <div className={`reisadvies ${loading ? "reisadvies--loading" : ""}`}>
            {ludMessages.map(({ text, url }) => (
              <div className="highlight" key={text}>
                {text}
              </div>
            ))}
            {!steps ? null : (
              <React.Fragment>
                {!differentDate ? null : (
                  <React.Fragment>
                    <ul className="accordion-bordered__group">
                      <li className="accordion-bordered__item accordion-bordered__item--warning">
                        <div className="accordion-bordered__info">
                          <Icon
                            iconName="storingen"
                            className="accordion-bordered__icon--left"
                          />
                          <span className="accordion-bordered__title">
                            Let op: Dit reisadvies geldt voor een andere dag.
                            Het kan zijn dat er geen reisadvies beschikbaar is
                            op de geselecteerde dag.
                          </span>
                        </div>
                      </li>
                    </ul>
                    <div>
                      <b>{dateString}</b>
                    </div>
                  </React.Fragment>
                )}

                <div className="reisadvies__steps">
                  {steps.map((step) => {
                    let startTimeDelay = step.startTimeDelay
                      ? Math.round(step.startTimeDelay / 1000 / 60)
                      : 0;
                    let endTimeDelay = step.endTimeDelay
                      ? Math.round(step.endTimeDelay / 1000 / 60)
                      : 0;
                    let startAddress = step.startAddress;
                    if (startAddress === "Beginpunt") {
                      startAddress = defaultStartAddress;
                    } else if (startAddress === "Eindpunt") {
                      startAddress = defaultEndAddress;
                    }

                    return (
                      <div
                        className={`reisadvies__step reisadvies__step--${step.mode.toLowerCase()}`}
                        key={`${step.startTime}-${startAddress}`}
                      >
                        <div className="reisadvies__start">
                          <div className="reisadvies__start-icon" />
                          <div className="reisadvies__start-time">
                            {moment(step.startTime).format("HH:mm")}
                            {startTimeDelay > 0 ? (
                              <span className="reisadvies__time-adjustment">
                                {" "}
                                +{startTimeDelay}{" "}
                                <span className="sr-only">
                                  {" "}
                                  {minutesDelayText}
                                </span>
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="reisadvies__start-address">
                            {startAddress}
                          </div>
                        </div>
                        {!step.mode ? null : this.renderTravelInfo(step)}
                        {!step.endTime ? null : (
                          <div className="reisadvies__end">
                            <div className="reisadvies__end-time">
                              {moment(step.endTime).format("HH:mm")}
                              {endTimeDelay > 0 ? (
                                <span className="reisadvies__time-adjustment">
                                  {" "}
                                  +{endTimeDelay}{" "}
                                  <span className="sr-only">
                                    {" "}
                                    {minutesDelayText}
                                  </span>
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
                <Sharing config={config ? config.sharing : {}} />
              </React.Fragment>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderTravelInfo(step) {
    let {
      directionText,
      busPreText,
      busPlatformText,
      subwayPreText,
      railPreText,
      tramPreText,
      ferryPreText,
      taxiPreText,
    } = this.props.config;

    directionText = directionText || "richting";
    busPreText = busPreText || "";
    busPlatformText = busPlatformText || "";
    subwayPreText = subwayPreText || "";
    railPreText = railPreText || "";
    tramPreText = tramPreText || "";
    ferryPreText = ferryPreText || "";
    taxiPreText = taxiPreText || "";
    const route = step.travelInfo ? step.travelInfo.route : "?";
    const agency = step.travelInfo ? step.travelInfo.agencyName : "?";

    if (step.mode === "WALK") return this.renderWalk(step);
    if (step.mode === "BUS") {
      return this.renderTransport(
        step,
        `${busPreText} ${route} - ${agency}`,
        `(${directionText} ${step.travelInfo.direction})`
      );
    }
    if (step.mode === "SUBWAY")
      return this.renderTransport(
        step,
        `${subwayPreText} ${route} - ${agency}`,
        `(${directionText} ${step.travelInfo.direction || "?"})`
      );
    if (step.mode === "RAIL")
      return this.renderTransport(
        step,
        `${railPreText} ${step.travelInfo.platform || "?"} - ${agency}`,
        `(${step.travelInfo.type || "?"} ${directionText} ${
          step.travelInfo.direction || "?"
        })`
      );
    if (step.mode === "TRAM")
      return this.renderTransport(
        step,
        `${tramPreText} ${route} - ${agency}`,
        `(${directionText} ${step.travelInfo.direction || "?"})`
      );
    if (step.mode === "FERRY")
      return this.renderTransport(
        step,
        `${ferryPreText} - ${agency} (${directionText} ${
          step.travelInfo.direction || "?"
        })`
      );
    if (step.mode === "PUBLICSTOPTAXI")
      return this.renderTransport(
        step,
        `${taxiPreText} - ${agency} (${directionText} ${
          step.travelInfo.direction || "?"
        })`
      );
    return null;
  }

  renderWalk({ startTime, endTime, mode, occupancy }) {
    let { walkPreText, walkPostText } = this.props.config;
    walkPreText = walkPreText || "";
    walkPostText = walkPostText || "";

    return (
      <div className="reisadvies__route">
        <div className="reisadvies__route-mode">
          <Icon
            className="reisadvies__route-icon"
            iconName="walk"
            title="Lopen"
          />
        </div>
        <div className="reisadvies__route-info">
          <div className="reisadvies__route-description">
            {walkPreText} {Math.round((endTime - startTime) / 1000 / 60)}{" "}
            {walkPostText}
          </div>
        </div>
      </div>
    );
  }

  renderTransport(
    { travelInfo, mode, startTime, remarks = [], occupancy },
    from,
    direction
  ) {
    let {
      haltesHideButtonText = "Verberg haltes",
      haltesShowButtonText = "Toon haltes",
      minutesDelayText = "minuten vertraging",
      busPlatformText,
    } = this.props.config;

    const remark = remarks.length ? remarks[0].Value : "";
    const stepExtraIsVisible =
      !!this.state.stepExtraIsVisible[`${startTime}-${from}`];

    return (
      <React.Fragment>
        <div className="reisadvies__route">
          <div className="reisadvies__route-mode">
            <Icon
              className="reisadvies__route-icon"
              iconName={mode.toLowerCase()}
              title={`Routestap type ${mode.toLowerCase()}`}
            />
          </div>
          <div className="reisadvies__route-info">
            <div className="reisadvies__route-description">
              {mode === "BUS" && travelInfo.platform && (
                <div>
                  {busPlatformText}: {travelInfo.platform}
                </div>
              )}
              {`${from} `}
              {direction ? (
                <span className="reisadvies__route-direction">
                  {direction}{" "}
                </span>
              ) : (
                ""
              )}
              {getOccupancySpan("reisadvies__occupancy", occupancy)}
              {remark ? (
                <span className="reisadvies__remark">{remark}</span>
              ) : (
                ""
              )}
            </div>
            {!travelInfo.stops.length ? null : (
              <button
                className="reisadvies__extra-toggle toggle btn--reset link link--icon-on-hover print-hide"
                onClick={() => this.toggleStops(startTime, from)}
              >
                {stepExtraIsVisible ? (
                  <React.Fragment>
                    {haltesHideButtonText}
                    <Icon
                      iconName="chevron-up"
                      className="reisadvies__extra-toggle-icon reisadvies__extra-toggle-icon--open"
                    />
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {haltesShowButtonText}
                    <Icon
                      iconName="chevron-down"
                      className="reisadvies__extra-toggle-icon reisadvies__extra-toggle-icon--closed"
                    />
                  </React.Fragment>
                )}
              </button>
            )}
          </div>
        </div>
        <div
          className={`reisadvies__extra ${
            stepExtraIsVisible
              ? "reisadvies__extra--open"
              : "reisadvies__extra--closed"
          }`}
        >
          {!travelInfo.stops.length
            ? null
            : travelInfo.stops.map((stop, index) => (
                <div
                  className="reisadvies__stop"
                  key={`${stop.time}-${stop.address}`}
                >
                  <div className="reisadvies__stop-icon" />
                  <div className="reisadvies__stop-time">
                    {stop.time ? moment(stop.time).format("HH:mm") : null}
                    {stop.timeDelay && stop.timeDelay > 0 ? (
                      <span className="reisadvies__time-adjustment">
                        {" "}
                        +{stop.timeDelay}{" "}
                        <span className="sr-only"> {minutesDelayText}</span>
                      </span>
                    ) : null}
                  </div>
                  <div className="reisadvies__stop-address">
                    {this.renderStopAddress(stop)}
                  </div>
                </div>
              ))}
        </div>
        <ReactModal
          isOpen={this.state.showModal}
          style={{ overlay: {}, content: {} }}
          overlayClassName="modal__overlay"
          bodyOpenClassName="modal--open"
          shouldFocusAfterRender={false}
          className="modal"
        >
          <button onClick={this.handleCloseModal} className="modal__close-btn">
            ✖
          </button>
          <div className="modal__content">
            <h2>Halte: {this.state.stopAddress}</h2>
            {/* @TODO: Dit moet nog dynamisch gemaakt worden */}
            <Accessibility
              types={[
                "blind-yes",
                "blind-no",
                "wheelchair-yes",
                "wheelchair-no",
              ]}
            />
            <button>
              Halte-informatie{" "}
              <Icon
                className="btn__icon btn__icon--right"
                iconName="arrow-right"
              />
            </button>
          </div>
        </ReactModal>
      </React.Fragment>
    );
  }

  isValidStopId(stopId) {
    if (!stopId) return false;
    if (stopId.indexOf("NL-TRAIN") !== -1) return false;
    if (stopId.indexOf("NL-NOTRAIN") !== -1) return false;
    return true;
  }

  createStopLink = (stop) => {
    const baseUrl = this.props.config.halteLinkBaseUrl || "/";
    const nameAndTown = stop.address.split(",");

    let stopid = "";
    if (this.isValidStopId(stop.stopId)) {
      stopid = stop.stopId;
    } else if (stop.stopCode) {
      stopid = `NL:S:${stop.stopCode}`;
    }

    const queryStringParam = {
      stopid,
      town: nameAndTown.length ? nameAndTown[0] : "?",
      name: nameAndTown.length >= 2 ? nameAndTown[1] : "?",
    };

    return `${baseUrl}?stop=${JSON.stringify(queryStringParam)}`;
  };

  renderStopAddress = (stop) => {
    if (!this.isValidStopId(stop.stopId) && !stop.stopCode) {
      return stop.address;
    } else {
      return <a href={this.createStopLink(stop)}>{stop.address}</a>;
    }
  };

  toggleStops = (startTime, from) => {
    const stepExtraIsVisible = this.state.stepExtraIsVisible;
    stepExtraIsVisible[`${startTime}-${from}`] =
      !stepExtraIsVisible[`${startTime}-${from}`];
    this.setState({
      stepExtraIsVisible,
    });
  };
}

function convertPlanToSteps(plan, origin, destination) {
  const steps = [];

  plan.legs.forEach((leg) => {
    if (leg.from.name === "Origin") leg.from.name = origin;
    if (leg.from.name === "Destination") leg.from.name = destination;

    if (leg.to.name === "Origin") leg.to.name = origin;
    if (leg.to.name === "Destination") leg.to.name = destination;

    //OTP
    let startTimeDelay = leg.departureDelay;
    let endTimeDelay = leg.arrivalDelay;
    //9292
    if (!startTimeDelay && leg.from && leg.from.realtimeDeparture) {
      startTimeDelay = Math.round(
        leg.from.realtimeDeparture - leg.from.departure
      );
    }
    if (!endTimeDelay && leg.to && leg.to.realtimeArrival) {
      endTimeDelay = Math.round(leg.to.realtimeArrival - leg.to.arrival);
    }

    const step = {
      startTime: leg.startTime,
      startTimeDelay,
      startAddress: leg.from.name === "Origin" ? origin : leg.from.name,
      endTime: leg.endTime,
      endTimeDelay,
      mode: leg.mode,
      remarks: leg.remarks || [],
      occupancy: leg.occupancy,
    };

    if (leg.mode === "WALK") {
      step.travelInfo = {};
    } else if (leg.mode === "BUS") {
      step.travelInfo = {
        platform: leg.from.platformCode,
        route: leg.routeShortName,
        direction: leg.headsign,
        agencyName: leg.agencyName || leg.agencyId,
        stops: leg.intermediateStops.map((stop) => ({
          time: stop.departure,
          address: stop.name,
          stopId: stop.stopId,
          stopCode: stop.stopCode,
        })),
      };
    } else if (leg.mode === "RAIL") {
      step.travelInfo = {
        platform: leg.from.platformCode,
        type: leg.route || leg.routeShortName,
        direction: leg.headsign,
        agencyName: leg.agencyName || leg.agencyId,
        stops: leg.intermediateStops.map((stop) => ({
          time: stop.departure,
          address: stop.name,
          stopId: stop.stopId,
          stopCode: stop.stopCode,
        })),
      };
    } else if (leg.mode === "TRAM") {
      step.travelInfo = {
        route: leg.route,
        direction: leg.headsign,
        agencyName: leg.agencyName || leg.agencyId,
        stops: leg.intermediateStops.map((stop) => ({
          time: stop.departure,
          address: stop.name,
          stopId: stop.stopId,
          stopCode: stop.stopCode,
        })),
      };
    } else if (leg.mode === "SUBWAY") {
      step.travelInfo = {
        route: leg.route || leg.routeShortName,
        direction: leg.headsign,
        agencyName: leg.agencyName || leg.agencyId,
        stops: leg.intermediateStops.map((stop) => ({
          time: stop.departure,
          address: stop.name,
          stopId: stop.stopId,
          stopCode: stop.stopCode,
        })),
      };
    } else if (leg.mode === "FERRY") {
      step.travelInfo = {
        direction: leg.headsign,
        agencyName: leg.agencyName || leg.agencyId,
        stops: leg.intermediateStops.map((stop) => ({
          time: stop.departure,
          address: stop.name,
          stopId: stop.stopId,
          stopCode: stop.stopCode,
        })),
      };
    } else if (leg.mode === "PUBLICSTOPTAXI") {
      step.travelInfo = {
        direction: leg.headsign,
        agencyName: leg.agencyName || leg.agencyId,
        stops: leg.intermediateStops.map((stop) => ({
          time: stop.departure,
          address: stop.name,
          stopId: stop.stopId,
          stopCode: stop.stopCode,
        })),
      };
    } else {
      console.error("Unknown step:", leg);
      return;
    }

    steps.push(step);
  });

  steps.push({
    startTime: plan.legs[plan.legs.length - 1].endTime,
    startAddress: destination,
    mode: "DESTINATION",
    occupancy: 0,
  });

  return steps;
}

export default connect((state) => {
  const {
    plans,
    selectedIndex,
    loading,
    origin,
    destination,
    isTexelhopperFlexAvailable,
    selectedDate,
    plannerType,
  } = state.reisadviezen;
  const plan =
    !isTexelhopperFlexAvailable && plans && selectedIndex !== -1
      ? plans[selectedIndex]
      : null;

  return {
    steps: plan ? convertPlanToSteps(plan, origin, destination) : null,
    ludMessages: plan ? plan.ludMessages : [],
    loading: loading || getIsRequiredFlexLoading(state),
    selectedDate: plan ? selectedDate : null,
    plannerType: plannerType,
  };
}, {})(Detail);



// WEBPACK FOOTER //
// ./src/components/Reisadviezen/Detail.js